export default [
  {
    id: 1,
    label: "보호구",
    check: false,
    title: "보호구",
    list: [
      {
        id: 1,
        label: "보호구 착용 및 관리상태(청력, 호흡용)가 적절 한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "기타 보호구 착용 및 관리상태가 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "적절한 보호구(적격품)를 지급하고 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 2,
    label: "환기 및 배기장치",
    check: false,
    title: "환기 및 배기장치",
    list: [
      {
        id: 1,
        label: "환기상태 및 환기설비 작동상태는 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "국소 배기장치 상태 및 작동, 관리는 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "밀폐공간 주기적인 점검 및 파악(산소농도, 자연환기, 환기 사용 점검 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 3,
    label: "표지",
    check: false,
    title: "표지",
    list: [
      {
        id: 1,
        label: "안전보건표지는 적절히 부착되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "산업안전보건법령요지는 눈에 띄는 곳에 게시되 어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "화학물질 취급시 MSDS 게시 및 부착의무, 작업 공정별 관리요령 게시가 이루어져 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 4,
    label: "작업자세",
    check: false,
    title: "작업자세",
    list: [
      {
        id: 1,
        label: "작업자세/동선 및 중량물 취급자세 (중량물 취급시 2인 1조 작업/ 이동보조도구 활 용 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 5,
    label: "작업장",
    check: false,
    title: "작업장",
    list: [
      {
        id: 1,
        label: "작업장 내 정리정돈, 위생상태/ 소화기 유무, 관리 상태 (통로확보, 분리수거함 등)\n",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "시설물 파손여부, 청소, 점검 등 관리상태",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "인화성물질(휘발유, 등유, 경유 등)은 안전하게 관리되고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "화학물질 소분용기에 경고표지가 부착되어 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 6,
    label: "근로자",
    check: false,
    title: "근로자",
    list: [
      {
        id: 1,
        label: "근로자의 부상, 외상 등 조치할 수 있는 응급구급함이 갖추어져 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "근로자의 정기적인 건강진단을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "교대근무 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "근로자의 질병 예방 및 사후관리 방안이 활용되 고 있는가? (휴식시간, 휴게시설, 유연근무제 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 7,
    label: "교육",
    check: false,
    title: "교육",
    list: [
      {
        id: 1,
        label: "매달 정기안전보건교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "신규 근로자의 경우 안전보건교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "근로자의 특별교육 해당일 경우 이를 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "MSDS교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 8,
    label: "직업성 질환",
    check: false,
    title: "직업성 질환",
    list: [
      {
        id: 1,
        label: "하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "하루 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세의 작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "하루 총 2시간 이상 4.5kg이상의 물건을 한 손으 로 들거나 동일한 힘으로 쥐는 작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "5kg이상 중량물 취급 시 중량물 취급안내표시가 부착되어있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "근무시 기타 질환 유발요인들이 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 9,
    label: "휴게시설",
    check: false,
    title: "휴게시설",
    list: [
      {
        id: 1,
        label: "휴게시설은 마련되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "기준에 적합한가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 10,
    label: "온열질환",
    check: false,
    title: "온열질환",
    list: [
      {
        id: 1,
        title:"(물) 시원한 물 자주 마시기",
        label: "시원하고 깨끗한 물을 충분히 제공/식염포도당을 충분히 제공",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        title:"(바람·그늘) 실내·옥외 작업장 온도 낮추기",
        label: "기준에 적합한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        title:"(바람·그늘) 실내·옥외 작업장 온도 낮추기",
        label: "작업시간대 조정 등 폭염 집중 시간대 노출 최소화",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        title:"(휴식) 주기적으로 쉬기",
        label: "작업장소와 가까운 곳에 휴게시설(쉼터) 설치, (이동식)에어컨, 산업용 선풍기, 시원한 물 비치",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        title:"(휴식) 주기적으로 쉬기",
        label: "체감온도 31 도 이상 폭염작업 시 적절한 휴식",
        is_checked: "",
        note: "",
      },
      {
        id: 6,
        title:"(휴식) 주기적으로 쉬기",
        label: "체감온도 33도 이상 폭염작업 시 2시간 이내 20분 이상 휴식",
        is_checked: "",
        note: "",
      },
      {
        id: 7,
        title:"(보냉장구) 근로자 체온 낮추기",
        label: "냉각의류, 냉각조끼 등 개인 보냉장구 지급",
        is_checked: "",
        note: "",
      },
      {
        id: 8,
        title:"(응급조치) 119에 신고하기",
        label: "온열질환자·의심자가 의식이 없는 경우 즉시 119 에 신고",
        is_checked: "",
        note: "",
      },
      {
        id: 9,
        title:"(응급조치) 119에 신고하기",
        label: "의식이 있는 경우 응급조치 후 증상 개선 없을 시 119 신고",
        is_checked: "",
        note: "",
      },
      {
        id: 10,
        title:"그 외 예방조치",
        label: "작업장소의 체감온도를 알 수 있는 온습도계 비치",
        is_checked: "",
        note: "",
      },
      {
        id: 11,
        title:"그 외 예방조치",
        label: "온열질환 증상 및 예방방법 , 응급조치 요령 교육",
        is_checked: "",
        note: "",
      },
      {
        id: 12,
        title:"그 외 예방조치",
        label: "체감온도를 측정하고 조치사항 기록·보관",
        is_checked: "",
        note: "",
      },
      {
        id: 13,
        title:"그 외 예방조치",
        label: "온열질환 민감군 관리계획 수립<br/>* 신규배치자, 과거 온열질환 경력자, 고령자 등",
        is_checked: "",
        note: "",
      },
      {
        id: 14,
        title:"그 외 예방조치",
        label: "자율점검표, 자가진단표, 온열질환 예방지침 게시",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 11,
    label: "한랭질환",
    check: false,
    title: "한랭질환",
    list: [
      {
        id: 1,
        title:"따뜻한 옷 (방한구)",
        label: "여러 겹의 옷, 방한모, 장갑 착용",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        title:"따뜻한 옷 (방한구)",
        label: "보온 장갑 및 보온·방수기능 신발 착용",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        title:"따뜻한 물",
        label: "따뜻하고 깨끗한 물 제공",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        title:"따뜻한 쉼터",
        label: "(휴게시설) 휴식시간에 이용할 수 있는 휴게시설 설치",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        title:"따뜻한 쉼터",
        label: "(휴게시설) 휴게시설 크기, 온도, 위치 등 적정기준 준수 여부 확인",
        is_checked: "",
        note: "",
      },
      {
        id: 6,
        title:"따뜻한 쉼터",
        label: "(쉼터) 휴게시설 설치장소 이외 작업장소와 가까운 곳에 추위를 피할 수 있는 따뜻한 쉼터 마련<br/>- 난방장치 설치 시 화재 또는 유해가스 중독 우려가 없도록 설치",
        is_checked: "",
        note: "",
      },
      {
        id: 7,
        title:"따뜻한 쉼터",
        label: "(쉼터) 한파특보 발령시 적절하게 휴식 부여",
        is_checked: "",
        note: "",
      },
      {
        id: 8,
        title:"작업시간대 조정",
        label: "한파특보(주의보) 발령 시 작업시간대 조정 또는 작업시간 단축",
        is_checked: "",
        note: "",
      },
      {
        id: 9,
        title:"작업시간대 조정",
        label: "한파특보(경보) 발령 시 추운시간대(새벽) 옥외 작업중지 또는 최소화",
        is_checked: "",
        note: "",
      },
      {
        id: 10,
        title:"응급조치",
        label: "야외 작업자의 한랭질환 의심자 발생시 즉시 119 신고",
        is_checked: "",
        note: "",
      },
      {
        id: 11,
        title:"응급조치",
        label: "근로자에게 한랭질환 예방·응급조치 교육 실시",
        is_checked: "",
        note: "",
      },
      {
        id: 12,
        title:"기타",
        label: "한랭질환 예방가이드와 자율점검표를 근로자가 쉽게 볼 수 있는 위치에 게시",
        is_checked: "",
        note: "",
      },
      {
        id: 13,
        title:"기타",
        label: "운동지도 및 민감군 사전관리<br/>* (민감군) 고혈압, 당뇨, 뇌심혈관질환, 갑상선 기능저하, 허약체질, 고령자, 신규배치자 등",
        is_checked: "",
        note: "",
      },
    ],
  },
];
